/**
 * Переиспользуемый компонент поиска с debounce
 */

import React, { useState, useEffect } from 'react'
import { Search, X } from 'lucide-react'

const SearchInput = ({ 
  value = '', 
  onChange, 
  placeholder = 'Поиск...', 
  debounceMs = 300,
  className = '',
  disabled = false
}) => {
  const [localValue, setLocalValue] = useState(value)

  // Debounce для оптимизации поиска
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (onChange) {
        onChange(localValue)
      }
    }, debounceMs)

    return () => clearTimeout(timeoutId)
  }, [localValue, onChange, debounceMs])

  // Синхронизация с внешним значением
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleClear = () => {
    setLocalValue('')
    if (onChange) {
      onChange('')
    }
  }

  return (
    <div className={`relative ${className}`}>
      <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      <input
        type="text"
        placeholder={placeholder}
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        disabled={disabled}
        className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-50 disabled:text-gray-500"
      />
      {localValue && (
        <button
          onClick={handleClear}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          disabled={disabled}
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  )
}

export default SearchInput 